export default __webpack_public_path__ + "static/media/facebookAuth.2e8576c6.svg";